import * as React from 'react';
import css from './ExploreSuggestPanel.module.scss';

interface Props extends React.HTMLProps<{}> {
  heading: string;
  handleClose: (flag: boolean) => void;
}

class ExploreSuggestPanel extends React.PureComponent<Props> {
  public static defaultProps: Props = {
    heading: 'foo',
    handleClose: (_: boolean) => undefined,
  };

  constructor(props: Props) {
    super(props);

    this.handleClose = this.handleClose.bind(this);
  }

  private handleClose() {
    this.props.handleClose(false);
  }
  public render() {
    return (
      <div className={css.ExploreSuggestPanel}>
        <div className={css.ExploreSuggestPanel__Heading}>
          <div>{this.props.heading}</div>
          <svg
            className={css.ExploreSuggestPanel__CloseIcon}
            onClick={this.handleClose}
          >
            <use xlinkHref="#close" />
          </svg>
        </div>
        {this.props.children}
      </div>
    );
  }
}

export default ExploreSuggestPanel;
